var exports = {
  "tJ": "metadataContainer__96Nc0m",
  "ut": "metadataContainer_stickyHeader__VFVzP2",
  "_b": "metadataBorder__n2DeBH",
  "QD": "metadataBorder_inlineAvatars__vkh3R7",
  "TT": "metadataBorder_stickyHeader__zyix_B",
  "xe": "metadataContent__tO2lBl",
  "Xp": "stickyContainer__Chi3ru",
  "Vp": "stickyContent__JSxAHz",
  "b_": "titleAndMetadata__rhT5IK",
  "x9": "smallMetadataRow__gR9GFk",
  "Aw": "smallMetadataRow_viewport__Mc1gzB",
  "dx": "smallMetadataRow_container__fTgckx",
  "KU": "metadataContainerSticky__fmQDHm",
  "Lh": "stickyContainerVisible__cmunfB",
  "PT": "stickyContainerHidden__wy3FC8",
};

module.exports = exports;
